import ShareMsgBase from './A_G.ShareMsgBase';

class MsgTreasureHuntComplete extends ShareMsgBase {
  /**
   * The message that gets sent when you finish the treasure hunt and you want to brag
   * @param {string} user1AvatarURL
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1AvatarURL, onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    this.avatar1 = this._addExtImage(251, 79, user1AvatarURL, 0, 189, null);
    this.bg = this._addExtImage(0, 0, 'img/Share_TreasureHunt_Complete.png', 0, null, null);
  }
}

G.MsgTreasureHuntComplete = MsgTreasureHuntComplete;
